import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { UtilitiesService } from '@app/shared/services/utilities.service';
import { FilterObject } from '@app/interfaces';
import { RootService } from '../../../core/root.service';
import { FiltersInlineService } from '@app/shared/services/filters-inline.service';

import { FormGroup, FormBuilder } from '@angular/forms';
import { EMPTY } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';
import { SHARED_IMPORTS } from '@app/shared/shared.imports';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { LanguageService } from '@app/core';

@Component({
  selector: 'app-list-grid-options',
  templateUrl: './list-grid-options.component.html',
  styleUrls: ['./list-grid-options.component.scss'],
  standalone: true,
  imports: [...SHARED_IMPORTS, FlexLayoutModule]
})
export class ListGridOptionsComponent {
  form: FormGroup;
  searchKey: string;
  activeLink: string;
  @Input() groupView: any;
  @Input() listOptions: any;
  @Input() controller: any;
  @Input() item: any;
  @Input() title: any;
  @Input() showTitle: boolean;
  @Input() service: RootService | any;

  @Output() openForm: EventEmitter<boolean> = new EventEmitter<boolean>();

  exportAsList: ExportAsItem[] = [
    {
      type: 'csv',
      icon: 'file-download-outline'
    },
    {
      type: 'xls',
      icon: 'file-download-outline'
    },
    {
      type: 'xlsx',
      icon: 'file-download-outline'
    },
    {
      type: 'pdf',
      icon: 'file-download-outline'
    }
  ];

  constructor(
    private router: Router,
    private us: UtilitiesService,
    private filtersInlineService: FiltersInlineService,
    private languageService: LanguageService,
    private fb: FormBuilder
  ) {}
  initForm(name: string) {
    let obj: any = {};
    obj[name] = [''];
    this.form = this.fb.group(obj);
  }

  // doAction(actionType: string, options?: {}) {
  //   this.doActionEvent.emit({ actionType, options });
  // }
  // tslint:disable-next-line:use-lifecycle-interface
  ngOnInit() {
    if (this.service.links && this.service.links.length > 0) {
      this.activeLink = this.service.customFilterActiveLink;
    }
    this.searchKey = this.service.searchKey;
    this.initForm(this.searchKey);
    this.Search();
  }
  navToCreate() {
    // return this.router.navigate([`${this.router.url}/create`]);
    // this.openDialog(this.formComponent);
    this.openForm.emit(true);
  }

  filter(filterby: FilterObject) {
    this.service.customFilterActiveLink = filterby.value;
    this.us.setFilters(this.service.refactorFilters({}));
  }
  Search() {
    this.form.controls[this.searchKey].valueChanges
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        tap(() => {
          (this.filtersInlineService.formData as any)[this.searchKey] = this.form.controls[this.searchKey].value;
          // console.log('this.filtersInlineService.formData',this.filtersInlineService.formData);
          this.us.setFilters(this.refactorFilters(this.filtersInlineService.formData));
        }),
        switchMap(() => {
          return EMPTY;
        })
      )
      .subscribe();
  }

  refactorFilters(formValue: any) {
    return this.service.refactorFilters(formValue);
  }

  get isEnglish(): boolean {
    return this.languageService.isEnglish;
  }
}

/**
 * Local Interface for prop: exportAsList
 */
interface ExportAsItem {
  type: string;
  icon: string;
}
